import { iconCheck } from "@kensho/icons";
import { Button, Overlay, Tooltip } from "@kensho/neo";
import { useState } from "react";

import { UpdateTranscriptSelectionType } from "../../../hooks/use-transcript-selection";
import { TranscriptEditAction } from "../../../utils/transcript-revision-utils";
import { Reviewer, ReviewItem } from "../transcript/review/reviewer";

interface Props {
  onEditOperationError: (error: Error, action: TranscriptEditAction) => void;
  updateTranscriptSelection: UpdateTranscriptSelectionType;
  scrollTranscriptToTime: (timeMs: number) => Promise<void>;
}

export function ReviewButton(props: Props) {
  const {
    onEditOperationError,
    updateTranscriptSelection,
    scrollTranscriptToTime,
  } = props;
  const [isOpen, setIsOpen] = useState(false);

  const [items, setItems] = useState<ReviewItem[]>([]);

  return (
    <>
      <Tooltip content="Review" position="bottom">
        <Button
          minimal
          icon={iconCheck}
          intent="primary"
          onClick={() => {
            setIsOpen((prev) => !prev);
          }}
          aria-label="Review"
        />
      </Tooltip>
      <Overlay backdrop={null} isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <div className="pointer-events-auto fixed top-24 right-2 h-[260px] w-[380px] overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/10">
          <Reviewer
            onEditOperationError={onEditOperationError}
            onClose={() => setIsOpen(false)}
            updateTranscriptSelection={updateTranscriptSelection}
            scrollTranscriptToTime={scrollTranscriptToTime}
            items={items}
            setItems={setItems}
          />
        </div>
      </Overlay>
    </>
  );
}
